import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Endpoints } from '@shared/Endpoints';
import { TImportMappingItem } from '@shared/interfaces/TImportMappingItem';
import { environment } from 'src/environments/environment';
import { CSVUtils } from 'src/utils/csvUtils';
import { LoadingService, TLoadingItem } from './loading.service';

@Injectable()
export class ImportService {
  constructor(
    private _loadingService: LoadingService,
    private _http: HttpClient
  ) {}

  public async importBricksSales(e: Event, callback: () => void, projectId: string, mappings: TImportMappingItem[]): Promise<void> {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem('Importing bricks sales');
    this._loadingService.addLoadingItem(loadingItem);
    const files: FileList | null = target.files;
    const url: string = Endpoints.BUILD_URL('import', {
      base: environment.apiUrl,
      endpoint: 'regionBricksSales',
      params: '',
    });
    const formData = await CSVUtils.getImportFormData(files![0], projectId, mappings);
    const response = this._http.post<string[]>(url, formData);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (res) => {
        callback();
        this._loadingService.removeItem(loadingItem);
        this._loadingService.triggerOkMessage('Importing bricks sales finished');
      },
    });
  }

  public async importBricksSalesInEuro(e: Event, callback: () => void, projectId: string, mappings: TImportMappingItem[]): Promise<void> {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem('Importing bricks sales in Euro');
    this._loadingService.addLoadingItem(loadingItem);
    const files: FileList | null = target.files;
    const url: string = Endpoints.BUILD_URL('import', {
      base: environment.apiUrl,
      endpoint: 'regionBricksSalesInEuro',
      params: '',
    });
    const formData = await CSVUtils.getImportFormData(files![0], projectId, mappings);
    const response = this._http.post<string[]>(url, formData);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (res) => {
        callback();
        this._loadingService.removeItem(loadingItem);
        this._loadingService.triggerOkMessage('Importing bricks sales in € finished');
      },
    });
  }

  public async importBricksPatients(e: Event, callback: () => void, projectId: string, mappings: TImportMappingItem[]): Promise<void> {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem('Importing bricks Patients');
    this._loadingService.addLoadingItem(loadingItem);
    const files: FileList | null = target.files;
    const url: string = Endpoints.BUILD_URL('import', {
      base: environment.apiUrl,
      endpoint: 'regionBricksPatients',
      params: '',
    });
    const formData = await CSVUtils.getImportFormData(files![0], projectId, mappings);
    const response = this._http.post<string[]>(url, formData);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (res) => {
        callback();
        this._loadingService.removeItem(loadingItem);
        this._loadingService.triggerOkMessage(
          'Importing bricks Patients finished'
        );
      },
    });
  }

  public async importCompetitorsSales(e: Event, callback: () => void, projectId: string, mappings: TImportMappingItem[]): Promise<void> {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem('Importing competitors sales');
    this._loadingService.addLoadingItem(loadingItem);
    const files: FileList | null = target.files;
    const url: string = Endpoints.BUILD_URL('import', {
      base: environment.apiUrl,
      endpoint: 'competitorsSales',
      params: ''
    });
    const formData = await CSVUtils.getImportFormData(files![0], projectId, mappings);
    const response = this._http.post<string[]>(url, formData);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (res) => {
        callback();
        this._loadingService.removeItem(loadingItem);
        this._loadingService.triggerOkMessage('Importing competitors sales finished');
      },
    });
  }

  public async importCompetitorsSalesInEuro(e: Event, callback: () => void, projectId: string, mappings: TImportMappingItem[]): Promise<void> {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem('Importing competitors sales in €');
    this._loadingService.addLoadingItem(loadingItem);
    const files: FileList | null = target.files;
    const url: string = Endpoints.BUILD_URL('import', {
      base: environment.apiUrl,
      endpoint: 'competitorsSalesInEuro',
      params: ''
    });
    const formData = await CSVUtils.getImportFormData(files![0], projectId, mappings);
    const response = this._http.post<string[]>(url, formData);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (res) => {
        callback();
        this._loadingService.removeItem(loadingItem);
        this._loadingService.triggerOkMessage('Importing competitors sales in € finished');
      },
    });
  }

  public async importCompetitorsPatients(e: Event, callback: () => void, projectId: string, mappings: TImportMappingItem[]): Promise<void> {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem('Importing competitors patients');
    this._loadingService.addLoadingItem(loadingItem);
    const files: FileList | null = target.files;
    const url: string = Endpoints.BUILD_URL('import', {
      base: environment.apiUrl,
      endpoint: 'competitorsPatients',
      params: ''
    });
    const formData = await CSVUtils.getImportFormData(files![0], projectId, mappings);
    const response = this._http.post<string[]>(url, formData);
    response.subscribe({
      error: (err) => {
        console.error(err);
        this._loadingService.onError();
      },
      next: (res) => {
        callback();
        this._loadingService.removeItem(loadingItem);
        this._loadingService.triggerOkMessage('Importing competitors patients finished');
      },
    });
  }

}
